import { render, staticRenderFns } from "./ArticleShareButtonGroup.vue?vue&type=template&id=f18880c2&scoped=true&"
import script from "./ArticleShareButtonGroup.vue?vue&type=script&lang=js&"
export * from "./ArticleShareButtonGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18880c2",
  null
  
)

export default component.exports